export enum ProjectionType {
  Investments = 'Investments',
  Pensions = 'Pensions',
}

export default [ProjectionType.Investments, ProjectionType.Pensions];
